import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { Trophy, Swords, Flame, ArrowLeft } from "lucide-react";
import ClanLogo from "../components/clan/ClanLogo";

export default function MatchesPage() {
  const [live, setLive] = useState([]);
  const [history, setHistory] = useState([]);
  const [tab, setTab] = useState("live");

  useEffect(() => {
    let cancelled = false, sequence = 0;
    const refresh = async () => {
      const current = ++sequence;
      try {
        const [a,b] = await Promise.all([api.get("/matches/live"),api.get("/matches/history")]);
        if (!cancelled && current===sequence) {setLive(a.data || []);setHistory(b.data || []);}
      } catch { /* Keep the last successful result until the next fetch. */ }
    };
    refresh();
    const timer=setInterval(refresh,12000);
    window.addEventListener("focus",refresh);
    window.addEventListener("rivals:match-result-changed",refresh);
    return ()=>{cancelled=true;clearInterval(timer);window.removeEventListener("focus",refresh);window.removeEventListener("rivals:match-result-changed",refresh);};
  }, []);

  const data = tab === "live" ? live : history;

  // دالة مساعدة لتنسيق العرض BO1, BO3, BO5, BO7
  const getFormatLabel = (fmt) => {
    if (!fmt) return "BO3";
    return fmt.toUpperCase();
  };

  return (
    <div className="space-y-8" dir="rtl">
      {/* ── Header ── */}
      <div>
        <div className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full bg-gold-500/10 border border-gold-500/20 text-gold-500 text-xs font-bold mb-2">
          <Swords size={14} /> جدول المباريات
        </div>
        <h1 className="font-display font-black text-3xl md:text-5xl text-white">
          المباريات والمواجهات
        </h1>
        <p className="text-white/50 mt-1.5 text-sm">
          تابع المباريات المباشرة لحظة بلحظة واستعرض سجل نتائج آخر ٢٤ ساعة
        </p>
      </div>

      {/* ── Tabs Selector ── */}
      <div className="flex justify-end">
        <div className="w-full sm:w-auto">
          <div className="inline-flex items-center bg-[#111113]/90 border border-white/10 rounded-2xl p-1.5 shadow-xl">
            <button
              data-testid="tab-live-matches"
              onClick={() => setTab("live")}
              className={`px-6 py-2.5 rounded-xl text-xs font-bold inline-flex items-center gap-2 transition-all duration-300 ${
                tab === "live"
                  ? "bg-gold-500 text-black font-black shadow-[0_0_15px_rgba(255,204,0,0.3)]"
                  : "text-white/50 hover:text-white hover:bg-white/5"
              }`}
            >
              <Flame size={15} className={tab === "live" ? "text-black" : "text-destructive"} /> مباشر ({live.length})
            </button>
            <button
              data-testid="tab-history"
              onClick={() => setTab("history")}
              className={`px-6 py-2.5 rounded-xl text-xs font-bold inline-flex items-center gap-2 transition-all duration-300 ${
                tab === "history"
                  ? "bg-gold-500 text-black font-black shadow-[0_0_15px_rgba(255,204,0,0.3)]"
                  : "text-white/50 hover:text-white hover:bg-white/5"
              }`}
            >
              <Trophy size={15} /> سجل ٢٤ ساعة ({history.length})
            </button>
          </div>
    
        </div>
      </div>

      {/* ── Match Cards Grid / Empty State ── */}
      {data.length === 0 ? (
        <div className="bg-[#111113]/90 border border-white/10 rounded-2xl p-16 text-center text-white/40 space-y-2">
          <Trophy size={36} className="mx-auto text-white/20 mb-3" />
          <div className="font-bold text-base text-white">
            {tab === "live" ? "لا توجد مباريات مباشرة حالياً" : "لا توجد مباريات مسجلة في آخر ٢٤ ساعة"}
          </div>
          <p className="text-xs text-white/40">تابع الجدول قريباً أو استعد للتحدي القادم!</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="matches-grid">
          {data.map((m) => (
            <Link
              key={m.id}
              to={`/matches/${m.id}`}
              data-testid={`match-${m.id}`}
              className="bg-[#111113]/90 border border-white/10 hover:border-gold-500/40 rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl flex flex-col justify-between group"
            >
              <div>
                {/* شريط الحالة ونوع التنسيق */}
                <div className="flex items-center justify-between mb-4 pb-2.5 border-b border-white/5">
                  {m.status === "live" ? (
                    <div className="flex items-center gap-2">
                      <span className="live-dot" />
                      <span className="text-[11px] uppercase tracking-widest text-destructive font-black px-2 py-0.5 rounded-full border border-destructive/30 bg-destructive/10">مباشر</span>
                    </div>
                  ) : (
                    <span className="text-[11px] font-bold uppercase tracking-widest text-white/40 bg-white/5 px-2 py-0.5 rounded-full border border-white/10">
                      منتهية
                    </span>
                  )}
                  <span className="text-xs text-white/40 font-mono">
                    {m.game || "Call of Duty"} • <span className="text-gold-400 font-bold">{getFormatLabel(m.match_format)}</span>
                  </span>
                </div>

                {/* شبكة الفرق (الكلان A ضد الكلان B مع الشعارات) */}
                <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3 py-2" dir="ltr">
                  
                  {/* الكلان A */}
                  <div className="flex flex-col items-center text-center gap-2 min-w-0">
                    <ClanLogo
                      clan={{ logo: m.clan_a?.logo_url || m.clan_a?.logo }}
                      className="h-12 w-12 rounded-xl bg-gold-500/10 border border-gold-500/20 grid place-items-center text-gold-500 overflow-hidden shrink-0 shadow-md"
                      fallbackIconSize={20}
                    />
                    <div className="min-w-0 w-full">
                      <div className={`font-display font-black text-sm truncate ${m.winner_clan_id === m.clan_a_id ? "text-gold-400" : "text-white"}`}>
                        {m.clan_a?.tag}
                      </div>
                      <div className="text-[10px] text-white/40 truncate mt-0.5">{m.clan_a?.name}</div>
                    </div>
                  </div>

                  {/* النتيجة / VS */}
                  <div className="px-2">
                    {m.status === "finished" ? (
                      <div className="font-display font-black text-xl text-white bg-black/40 px-3 py-1.5 rounded-xl border border-white/10" dir="ltr">
                        {m.score_a} <span className="text-white/30">-</span> {m.score_b}
                      </div>
                    ) : (
                      <div className="font-display font-black text-sm text-gold-500 bg-gold-500/10 px-2.5 py-1 rounded-xl border border-gold-500/20">
                        VS
                      </div>
                    )}
                  </div>

                  {/* الكلان B */}
                  <div className="flex flex-col items-center text-center gap-2 min-w-0">
                    <ClanLogo
                      clan={{ logo: m.clan_b?.logo_url || m.clan_b?.logo }}
                      className="h-12 w-12 rounded-xl bg-gold-500/10 border border-gold-500/20 grid place-items-center text-gold-500 overflow-hidden shrink-0 shadow-md"
                      fallbackIconSize={20}
                    />
                    <div className="min-w-0 w-full">
                      <div className={`font-display font-black text-sm truncate ${m.winner_clan_id === m.clan_b_id ? "text-gold-400" : "text-white"}`}>
                        {m.clan_b?.tag}
                      </div>
                      <div className="text-[10px] text-white/40 truncate mt-0.5">{m.clan_b?.name}</div>
                    </div>
                  </div>

                </div>
              </div>

              {/* زر الدخول التفاعلي */}
              <div className="mt-4 pt-3 border-t border-white/5 flex items-center justify-center gap-1 text-xs text-white/40 group-hover:text-gold-400 font-bold transition">
                <span>استعراض تفاصيل ومجريات المباراة</span>
                <ArrowLeft size={13} className="transition-transform group-hover:-translate-x-1" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
